import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, createSlots as _createSlots, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "side-menu-field-descr text-truncate"
}
const _hoisted_2 = { class: "field-input pt-1" }

import SideMenuCardSection from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCardSection.vue";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";
import Tags from "~/cabinet/vue/interface/data/Tags.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "ClientTags"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    descr: {},
    tags: {},
    canEdit: { type: Boolean }
  }, {
    "modelValue": {
    required: true
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

let props = __props;

let model = _useModel<string[]>(__props, "modelValue");

let hasTagWithColor = props.tags.find(tag => !!tag.color);

function removeTag(tag: string) {
    let value = [...model.value];
    toggleArrayElement(value, tag, false);
    model.value = value;
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (__props.tags.length || _unref(model).length)
    ? (_openBlock(), _createBlock(SideMenuCardSection, {
        key: 0,
        class: "operator-side-menu-field",
        compact: ""
      }, {
        default: _withCtx(() => [
          (_unref(model).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.descr), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_select, {
              modelValue: _unref(model),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event)),
              persistent: false,
              placeholder: __props.descr,
              class: "w-100 tags-select",
              disabled: !__props.canEdit,
              multiple: "",
              filterable: "",
              clearable: __props.canEdit
            }, _createSlots({
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tags, (tag) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: tag.tag,
                    value: tag.tag
                  }, {
                    default: _withCtx(() => [
                      (_unref(hasTagWithColor))
                        ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                            key: 0,
                            class: _normalizeClass({'mr-1': true, 'text-muted': !tag.color}),
                            icon: "circle",
                            light: !tag.color,
                            bold: !!tag.color,
                            style: _normalizeStyle({
                            color: tag.color ?? undefined,
                            fontSize: '.5em',
                            transform: 'translateY(-.25em)'
                        })
                          }, null, 8, ["class", "light", "bold", "style"]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(tag.tag), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 2
            }, [
              (_unref(model).length)
                ? {
                    name: "tag",
                    fn: _withCtx(() => [
                      _createVNode(Tags, {
                        tags: _unref(model),
                        "possible-tags": __props.tags,
                        closable: "",
                        onClose: removeTag
                      }, null, 8, ["tags", "possible-tags"])
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["modelValue", "placeholder", "disabled", "clearable"])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})